window.addEventListener('load', function loadAllContent() {

  // check if weglot plugin is loaded
  function waitForWeglot(onReady) {
    if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
      onReady();
      setTimeout(moveWeglot, 50); // 0.5s delay (weglot loading)
    } else {
      setTimeout(() => waitForWeglot(onReady), 200);
    }
  }

  // change translations based on current weglot language
  function applyTranslations() {
    const lang = Weglot.getCurrentLang();

    const search = document.querySelector('.tt-desctop-parent-search .tt-dropdown-toggle');
    const cart = document.querySelector('.tt-desctop-parent-cart .tt-dropdown-toggle');
    const account = document.querySelector('.tt-desctop-parent-account .tt-dropdown-toggle');

    if (search) search.setAttribute('data-tooltip', lang === 'en' ? 'Search' : 'Pretraga');
    if (cart) cart.setAttribute('data-tooltip', lang === 'en' ? 'Cart' : 'Korpa');
    if (account) account.setAttribute('data-tooltip', lang === 'en' ? 'My Account' : 'Moj Nalog');

    document.querySelectorAll('.tt-product .tt-btn-quickview').forEach(btn => {
      btn.setAttribute('data-tooltip', lang === 'en' ? 'Quick view' : 'Brz pregled');
    });

    document.querySelectorAll('.tt-content-parent').forEach(el => {
      translateHotspotContent($(el), lang);
    });
  }

  function initTranslations() {
    waitForWeglot(function handleWeglotReady() {
      applyTranslations();
      Weglot.on('languageChanged', applyTranslations);
    });
  }

  initTranslations();

  function moveWeglot() {
    let weglotSwitcher = document.querySelector('.weglot-container') || document.querySelector('.wg-default');
    let mobileLocation = document.getElementById('weglot-mobile');
    let mobileMenu = document.querySelector('.mobile-menu')

    // If Weglot no weglot
    if (!weglotSwitcher || !mobileLocation) {
      console.log("Weglot not found to move!");
      return;
    }

    // save original position to know where to put back if desktop
    let originalParent = weglotSwitcher.parentNode;
    let originalNextSibling = weglotSwitcher.nextSibling;
    
    let originalPosition = weglotSwitcher.style.position;
    let originalBottom = weglotSwitcher.style.bottom;
    let originalRight = weglotSwitcher.style.right;
    let originalLeft = weglotSwitcher.style.left;
    let originalTop = weglotSwitcher.style.top;

    // move weglot language switch
    function handleWeglotPlacement() {
      if (window.innerWidth <= 1024) {
        // MOBILE
        if (weglotSwitcher.parentNode !== mobileLocation) {
          mobileLocation.appendChild(weglotSwitcher);
          mobileMenu.after(mobileLocation);

          weglotSwitcher.style.position = 'relative';
          weglotSwitcher.style.bottom = 'auto';
          weglotSwitcher.style.right = 'auto';
          weglotSwitcher.style.left = 'auto';
          weglotSwitcher.style.top = 'auto';
        }
      } else {
        // DESKTOP - return to original place
        if (weglotSwitcher.parentNode !== originalParent) {
          if (originalNextSibling) {
            originalParent.insertBefore(weglotSwitcher, originalNextSibling);
          } else {
            originalParent.appendChild(weglotSwitcher);
          }
          
          weglotSwitcher.style.position = originalPosition;
          weglotSwitcher.style.bottom = originalBottom;
          weglotSwitcher.style.right = originalRight;
          weglotSwitcher.style.left = originalLeft;
          weglotSwitcher.style.top = originalTop;
        }
      }
    }

    // initial
    handleWeglotPlacement();

    // on screen resize
    window.addEventListener('resize', handleWeglotPlacement);
  }

  // Manual filer translations
  function initFilterTranslations() {

    var FILTER_TRANSLATIONS = {

      // Shopify renders these titles in EN → translate to SR
      labels: {
        'Availability': 'Dostupnost',
        'Price':        'Cena',
        'Stories':      'Priče',
      },

      // Shopify renders these titles from sr.json → Weglot does not translate them → translate to EN
      srLabels: {
        'KUPOVINA PO:': 'SHOP BY:',
        // Add other sr.json titles here if needed
      },

      // Filter values: EN → SR
      values: {
        'In stock':     'Na stanju',
        'Out of stock': 'Nema na stanju',
        // 'New':       'Novo',
      },

      // Labels in the active filter section (rendered from the Shopify filter API)
      // SR on Serbian, EN on English
      activeLabels: {
        'Availability:': 'Dostupnost:',
        'Price:':        'Cena:',
      },

      // Shopify always writes the Serbian prefix from sr.json, regardless of the Weglot language
      removeTooltip: {
        srPrefix: 'Ukloni filter',
        enPrefix: 'Remove filter',
      },
    };

    // The observer is stored here so we can temporarily disconnect it
    // before mutating the DOM, preventing an infinite loop:
    // we change text → observer fires → we change text → ...
    var sidebarObserver = null;

    function pauseObserver() {
      if (sidebarObserver) sidebarObserver.disconnect();
    }

    function resumeObserver() {
      var sidebar = document.querySelector('.leftColumn.aside');
      if (sidebarObserver && sidebar) {
        sidebarObserver.observe(sidebar, { childList: true, subtree: true });
      }
    }

    // Stores the original text in data-filter-en only once, on first encounter.
    // The Shopify theme may already set data-en server-side — used as a reliable fallback.
    function saveOriginal(el) {
      if (!el.dataset.filterEn) {
        el.dataset.filterEn = el.dataset.en || el.textContent.trim();
      }
    }

    // Filter group titles: h3.tt-collapse-title
    // Two cases:
    //   a) EN text (e.g. "Availability") → translate to SR using labels
    //   b) SR text from sr.json (e.g. "KUPOVINA PO:") → translate to EN using srLabels
    function translateFilterLabels(lang) {
      document.querySelectorAll('.tt-collapse-title').forEach(function translateLabel(el) {
        saveOriginal(el);
        var original = el.dataset.filterEn;
        var translated;
        if (lang === 'en') {
          // Original is Serbian (rendered from sr.json) — translate to EN
          translated = FILTER_TRANSLATIONS.srLabels[original] || original;
        } else {
          // Original is English (rendered from Shopify EN locale) — translate to SR
          translated = FILTER_TRANSLATIONS.labels[original] || original;
        }
        if (el.textContent.trim() !== translated) el.textContent = translated;
      });
    }

    // Checkbox list values: .shopifyfiltres-js a
    function translateFilterCheckboxValues(lang) {
      document.querySelectorAll('.shopifyfiltres-js a').forEach(function translateCheckboxValue(el) {
        if (el.hasAttribute('data-tooltip')) return;
        saveOriginal(el);
        var original = el.dataset.filterEn;
        var translated = lang !== 'en'
          ? (FILTER_TRANSLATIONS.values[original] || original)
          : original;
        if (el.textContent.trim() !== translated) el.textContent = translated;
      });
    }

    // Active filter pills: span inside .forremoverealfiltres
    // HTML: <a class="forremoverealfiltres"><span>In stock</span></a>
    function translateActiveFilterPills(lang) {
      document.querySelectorAll('.filtres-js .forremoverealfiltres span').forEach(function translatePill(el) {
        saveOriginal(el);
        var original = el.dataset.filterEn;
        var translated = lang !== 'en'
          ? (FILTER_TRANSLATIONS.values[original] || original)
          : original;
        if (el.textContent.trim() !== translated) el.textContent = translated;
      });
    }

    // Active filter labels: <li>Availability:</li>
    function translateActiveFilterLabels(lang) {
      document.querySelectorAll('.filtres-js li').forEach(function translateActiveLabel(el) {
        if (el.querySelector('a')) return; // skip li elements that contain a link (those are pills)
        saveOriginal(el);
        var original = el.dataset.filterEn;
        var translated = lang !== 'en'
          ? (FILTER_TRANSLATIONS.activeLabels[original] || original)
          : original;
        if (el.textContent.trim() !== translated) el.textContent = translated;
      });
    }

    // ── 5. Remove tooltips: data-tooltip="Ukloni filter X" 
    // Shopify always writes the Serbian prefix "Ukloni filter" from sr.json.
    // English: "Remove filter In stock"
    // Serbian: "Ukloni filter Na stanju"
    function translateFilterRemoveTooltips(lang) {
      var srPrefix = FILTER_TRANSLATIONS.removeTooltip.srPrefix;
      var enPrefix = FILTER_TRANSLATIONS.removeTooltip.enPrefix;

      document.querySelectorAll('[data-tooltip]').forEach(function translateRemoveTooltip(el) {
        var tooltip = el.getAttribute('data-tooltip');

        // Shopify always writes the Serbian prefix — look for that
        if (!tooltip.startsWith(srPrefix)) return;

        // Save the EN filter value (the part after the prefix) only once
        if (!el.dataset.filterTooltipValueEn) {
          el.dataset.filterTooltipValueEn = tooltip.slice(srPrefix.length).trim();
        }

        var valueEn  = el.dataset.filterTooltipValueEn;
        var valueSr  = FILTER_TRANSLATIONS.values[valueEn] || valueEn;

        var newTooltip = lang === 'en'
          ? enPrefix + ' ' + valueEn
          : srPrefix + ' ' + valueSr;

        if (el.getAttribute('data-tooltip') !== newTooltip) {
          el.setAttribute('data-tooltip', newTooltip);
        }
      });
    }

    // ── Main function
    function applyFilterTranslations(lang) {
      pauseObserver();
      translateFilterLabels(lang);
      translateFilterCheckboxValues(lang);
      translateActiveFilterPills(lang);
      translateActiveFilterLabels(lang);
      translateFilterRemoveTooltips(lang);
      resumeObserver();
    }

    // ── MutationObserver: re-apply when Shopify AJAX replaces the sidebar ─────
    function observeSidebar() {
      var sidebar = document.querySelector('.leftColumn.aside');
      if (!sidebar) return;

      sidebarObserver = new MutationObserver(function onSidebarMutation() {
        // Short timeout to let Shopify finish rendering before we translate
        setTimeout(function applyAfterRender() {
          applyFilterTranslations(Weglot.getCurrentLang());
        }, 150);
      });

      sidebarObserver.observe(sidebar, { childList: true, subtree: true });
    }

    // Uses the outer waitForWeglot — already defined in the parent scope
    waitForWeglot(function onFilterWeglotReady() {
      applyFilterTranslations(Weglot.getCurrentLang());
      observeSidebar();
      Weglot.on('languageChanged', applyFilterTranslations);
    });

  }
  
  initFilterTranslations();

});
